import { OrderPartialMap } from '@/types/lists/ordering';
import { Ordering, OrganizationFilter, QueryOrganizationsArgs } from 'gql-types';

/********************
 * Organization Types
 ********************/
export namespace Organization {
    export type Filters = OrganizationFilter;
    export type Ordering = OrganizationOrdering;
    export type ListVariables = QueryOrganizationsArgs;
}

/** Organization Ordering */
type OrganizationOrdering = OrderPartialMap<{
    name: Ordering;
    createdAt: Ordering;
}>;

/** Dashboard Configuration */
export enum DashboardVariation {
    HOSPICE_DEMO = 'HOSPICE_DEMO',
    HOME_HEALTH_DEMO = 'HOME_HEALTH_DEMO',
    ELEANOR_HEALTH = 'ELEANOR_HEALTH',
    JET_HEALTH = 'JET_HEALTH',
    NORTH_STAR = 'NORTH_STAR',
    NORTH_STAR_UAT = 'NORTH_STAR_UAT',
}

export const DEFAULT_DASHBOARD_VARIATION = DashboardVariation.HOME_HEALTH_DEMO;

/** Syncable Resources */
export enum SyncableResource {
    CLINICIAN = 'CLINICIAN',
    CLINICIAN_APPOINTMENT = 'CLINICIAN_APPOINTMENT',
    EPISODE_OF_CARE = 'EPISODE_OF_CARE',
    ORDER = 'ORDER',
    PATIENT = 'PATIENT',
    VISIT = 'VISIT',
    VISIT_REQUEST = 'VISIT_REQUEST',
}
